import { ComponentChildren, h, JSX } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import LoadingDots from "./LoadingDots";
import { HEADER_HEIGHT } from "./specs";

import styles from "./Header.module.css";

type NativeHeaderProps = Omit<JSX.HTMLAttributes<HTMLElement>, "loading">;

enum Variant {
    Primary = "primary",
    Secondary = "secondary"
}

interface Props extends NativeHeaderProps {
    style?: CSSProperties;
    leftContent?: ComponentChildren;
    centerContent?: ComponentChildren;
    rightContent?: ComponentChildren;
    loading?: boolean;
    hasTrafficLight?: boolean;
    variant?: Variant;
}

function Header({
    class: cssClass,
    style,
    leftContent,
    centerContent,
    rightContent,
    loading,
    hasTrafficLight,
    variant = Variant.Primary,
    ...nativeHeaderProps
}: Props) {
    const headerStyle = {
        ...style,
        "--header-height": `${HEADER_HEIGHT}px`
    } as CSSProperties;

    return (
        <header
            {...nativeHeaderProps}
            class={classname(styles.header, cssClass, {
                [styles.hasTrafficLight]: hasTrafficLight,
                [styles.secondary]: variant === Variant.Secondary
            })}
            style={headerStyle}>
            <div class={classname(styles.leftContent, "noSelect")}>{leftContent}</div>
            <div class={classname(styles.centerContent, "noSelect")}>{centerContent}</div>
            <div class={classname(styles.rightContent, "noSelect")}>{rightContent}</div>
            {loading && <LoadingDots class={styles.loadingDots}/>}
        </header>
    );
}

export default Header;
export {
    Variant as HeaderVariant
};
